module.exports = __webpack_public_path__ + "img/merah.0b207075.png";